import React from 'react';
import { FormattedMessage } from 'react-intl';

import globalTranslations from '../../../i18n/globalTranslations';

const ClientLoginLink = () => (
  <span className="ClientLoginLink">
    <FormattedMessage {...globalTranslations.accountChangeClientSentence} />
  </span>
);

export default ClientLoginLink;
